import { render, staticRenderFns } from "./RecommendationsFeed.vue?vue&type=template&id=0456a6dc&"
import script from "./RecommendationsFeed.vue?vue&type=script&lang=js&"
export * from "./RecommendationsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports